var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fill: "none",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#CEDEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M71.4727 433.443C80.6647 366.649 126.129 311.272 187.283 287.87C159.67 267.732 141.689 235.14 141.689 198.423C141.689 137.41 191.327 87.7715 252.341 87.7715C313.354 87.7715 362.993 137.41 362.993 198.423C362.993 235.14 345.011 267.732 317.398 287.87C380.542 312.033 426.959 370.287 433.99 439.999C424.039 449.627 413.309 458.455 401.904 466.38L401.722 458.455C401.722 376.085 334.712 309.075 252.342 309.075C169.972 309.075 102.961 376.086 102.961 458.455V461.239C91.7159 452.84 81.1839 443.539 71.4727 433.443ZM174.885 198.423C174.885 155.714 209.632 120.967 252.341 120.967C295.05 120.967 329.797 155.714 329.797 198.423C329.797 241.133 295.05 275.88 252.341 275.88C209.632 275.88 174.885 241.133 174.885 198.423Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.8976a2fef013e179d51f91fcfb761993.svg";
export { ForwardRef as ReactComponent };